// extracted by mini-css-extract-plugin
export default {"privacyContainer":"Privacy_privacyContainer__i70Jo","privacyTitle":"Privacy_privacyTitle__Galwo","link":"Privacy_link__CHz7f"};